var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAutomationMediaReplaceMediaBlank = function SvgIconAutomationMediaReplaceMediaBlank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 84,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M12 18h6v6h-6zm0 12h6v6h-6zm48-6h-6v-6h6zm36 6v54H24V54H0V0h72v30zm-6 6H30v25.734l15-14.953 21 20.953 15-14.953 9 8.953zM24 48V30h42V6h-6v6h-6V6H18v6h-6V6H6v42h6v-6h6v6zm6 30h37.734L45 55.219 30 70.266zm60 0v-7.734l-9-9.047L70.266 72l6 6zM69 48q-1.218 0-2.11-.89Q66 46.22 66 45q0-1.218.89-2.11Q67.78 42 69 42t2.11.89q.89.89.89 2.11t-.89 2.11Q70.22 48 69 48"
  })));
};
export default SvgIconAutomationMediaReplaceMediaBlank;